import { render, staticRenderFns } from "./LogoSepet.vue?vue&type=template&id=38ed7bd2&"
import script from "./LogoSepet.vue?vue&type=script&lang=js&"
export * from "./LogoSepet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports